module.exports = __webpack_public_path__ + "static/img/interactive-img3.fd17197.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/interactive-img3.jpg
// module id = 329
// module chunks = 64